







































import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import { ConvertedRecommendItem } from '~/types/common/silverEgg';
import type { SwiperOptions } from 'swiper';

export default defineComponent({
  components: {},
  props: {
    name: {
      type: String,
      required: true,
    },
    items: {
      type: Array as PropType<ConvertedRecommendItem[]>,
      required: true,
    },
    visibleNavigation: {
      type: Number,
      default: 4,
    },
    // カートインモーダルで使用しているかどうか
    isCartInModal: {
      type: Boolean,
      default: false,
    },
    // 水平方向のパディングを除去する
    isRemoveHorizontalPadding: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const swiperOptions = computed(
      (): SwiperOptions => ({
        slidesPerView: 'auto',
        spaceBetween: 32,
        navigation: {
          nextEl: `#swiper-button-next-${props.name}`,
          prevEl: `#swiper-button-prev-${props.name}`,
        },
      })
    );

    return { props, swiperOptions };
  },
});
